import * as React from 'react';
import {observer} from 'mobx-react';
import * as classnames from 'classnames/bind';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';

const styles = require('./PropertiesContainer.less');
const cx = classnames.bind(styles);

interface IPropertiesContainerProps
{
    className?:string;
}

@observer
export class PropertiesContainer extends React.Component<IPropertiesContainerProps, any>
{
    render()
    {
        const {className} = this.props;
        const isVisible = controllers.ui.workbenchVisibility.isPropertiesPanelVisible();

        if( !isVisible )
        {
            return null;
        }

        return (
            <div className={cx('base', className)}>
                {this.props.children}
            </div>
        );
    }
}







